import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";

const LogContext = createContext();

export const useLogs = () => {
  const context = useContext(LogContext);
  if (!context) {
    throw new Error("useLogs must be used within a LogProvider");
  }
  return context;
};

export const LogProvider = ({ children, enabled = true }) => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (!enabled) setLogs([]);
  }, [enabled]);

  const addLog = useCallback((message) => {
    if (!enabled) return;
    const time = new Date().toLocaleTimeString();
    const msg = String(message ?? "");
    // If caller sends whitespace (e.g. " "), treat it as a visual line break (no timestamp).
    if (msg.trim() === "") {
      setLogs((prev) => [
        ...prev,
        {
          type: "break",
          time,
        },
      ]);
      return;
    }
    setLogs((prev) => [
      ...prev,
      {
        type: "text",
        time,
        message: msg,
      },
    ]);
  }, [enabled]);

  const addLogImage = useCallback((src, caption = "Captured photo") => {
    if (!enabled) return;
    const time = new Date().toLocaleTimeString();
    if (!src) return;
    setLogs((prev) => [
      ...prev,
      {
        type: "image",
        time,
        src,
        caption: String(caption),
      },
    ]);
  }, [enabled]);

  const value = useMemo(
    () => ({ logs, addLog, addLogImage }),
    [logs, addLog, addLogImage]
  );

  return (
    <LogContext.Provider value={value}>
      {children}
    </LogContext.Provider>
  );
};
